<script>
    export let message = "Da ist was schief gelaufen.";
</script>

<style>
    div {
        padding: 40px 20px;
    }
    p {
        width: 1000px;
        max-width: 100%;
        text-align: center;
    }
</style>

<div>
    <p>{message}</p>
</div>
